<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
         <el-form-item prop="name">
                <el-input size="small" v-model="searchForm.name" placeholder="名称" clearable></el-input>
         </el-form-item>
         <el-form-item prop="parentId">
                  <el-select v-model="searchForm.parentId" placeholder="请选择父栏目" size="small" style="width: 100%;">
                    <el-option
                      v-for="item in parentIdOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
         </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
      <div>
        <span>该模块是UM头部菜单数据</span>
      </div>
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <el-button v-if="hasPermission('ummcolumn:hearderLayout:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
            <!-- <el-button v-if="hasPermission('ummcolumn:hearderLayout:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.hearderLayoutTable && $refs.hearderLayoutTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('ummcolumn:hearderLayout:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.hearderLayoutTable && $refs.hearderLayoutTable.getCheckboxRecords().length === 0" plain>删除</el-button>
          </template>
          <template #tools>
            <vxe-button
    		  type="default"
    		  title="下载导入模板"
    		  v-if="hasPermission('ummcolumn:hearderLayout:import')"
    		  class="el-icon-document m-r-12"
    		  @click="downloadTpl()"
    		  circle
            >
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 80px);">
        <vxe-table
          ref="hearderLayoutTable"
          border="full"
          auto-resize
          resizable
          height="auto"
          row-id="id"
          size="small"
          show-header-overflow
          show-overflow
          highlight-hover-row
          :print-config="{}"
          :export-config="{}"
          :loading="loading"
          :checkbox-config="{checkStrictly: true}"
          :tree-config="{transform: true, expandAll: true, rowField: 'id', parentField: 'parentId'}"
          @toggle-tree-expand="toggleExpandChangeEvent"
          :data="dataList"
            >
            <vxe-column type="checkbox"  width="40px"></vxe-column>
    <vxe-column
        field="name"
        tree-node
        title="名称">
            <template slot-scope="scope">
              <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('ummcolumn:hearderLayout:edit')" @click="edit(scope.row.id)">{{scope.row.name}}</el-link> -->
              <el-link  type="primary" :underline="false" v-if="hasPermission('ummcolumn:hearderLayout:view')"  @click="view(scope.row.id)">{{scope.row.name}}</el-link>
              <span v-else>{{scope.row.name}}</span>
            </template>
      </vxe-column>
      <vxe-column
        field="valCn"
        align="center"
        title="中文值">
      </vxe-column>
    <vxe-column
        field="valEn"
        align="center"
        title="英文值">
      </vxe-column>
    <vxe-column
        field="url"
        align="center"
        title="链接或路由">
      </vxe-column>
    <vxe-column
        field="state"
        align="center"
        width="150"
        title="状态">
        <template slot-scope="scope">
              <!-- {{ $dictUtils.getDictLabel("show_hide", scope.row.state, '-') }} -->
                    <el-switch
                      v-if="scope.row.id != '0'"
                      v-model="scope.row.state"
                      @change="statusChange(scope.row)"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0">
                    </el-switch>
        </template>
      </vxe-column>
      <vxe-column
        field="author"
        align="center"
        width="100"
        title="作者">
        <template slot-scope="scope">
          {{ scope.row.author ? scope.row.author : '-' }}
        </template>
      </vxe-column>
      <vxe-column
        fixed="right"
        align="center"
        width="100"
        title="操作">
        <template  slot-scope="scope">
          <el-button v-if="hasPermission('ummcolumn:hearderLayout:add')" type="text" size="small" @click="addChild(scope.row.id)">创建子栏目</el-button>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager> -->
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <HearderLayoutForm  ref="hearderLayoutForm" @refreshDataList="refreshList"></HearderLayoutForm>
  </div>
</template>

<script>
  import VXETable from 'vxe-table'
  import HearderLayoutForm from './HearderLayoutForm'
  import hearderLayoutService from '@/api/ummcolumn/hearderLayoutService'
  export default {
    data () {
      return {
        searchForm: {
          name: '',
          parentId: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: true }]
        },
        loading: false,
        parentIdOption: []
      }
    },
    components: {
      HearderLayoutForm
    },
    activated () {
      this.refreshList()
      this.getHeardLayoutList()
    },
    methods: {
      toggleExpandChangeEvent ({ row, expanded }) {
        const $table = this.$refs.hearderLayoutForm
        console.log('节点展开事件', expanded, '获取父节点：', $table.getParentRow(row))
      },
      getTreeExpansionEvent () {
        const $table = this.$refs.hearderLayoutForm
        const treeExpandRecords = $table.getTreeExpandRecords()
        VXETable.modal.alert(treeExpandRecords.length)
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        hearderLayoutService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          // this.dataList.unshift({id: '0', name: 'UnitModeler'})
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 获取父栏目列表
      getHeardLayoutList () {
        this.loading = true
        hearderLayoutService.list({
          'current': '1',
          'size': '100'
        }).then(({data}) => {
          if (!data) return
          let mapList = data.records.filter(item => item.parentId === '0').map(mitem => {
            return { value: mitem.id, label: mitem.valCn }
          })
          mapList.unshift({ value: '0', label: '顶层' })
          this.parentIdOption = mapList
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增下级
      addChild (pid) {
        this.$refs.hearderLayoutForm.init('addChild', {id: '', parent: pid})
      },
      // 新增
      add (pid) {
        this.$refs.hearderLayoutForm.init('add', {id: pid, parent: ''})
      },
      // 修改
      edit (id) {
        id = id || this.$refs.hearderLayoutTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.hearderLayoutForm.init('edit', {id: id, parent: ''})
      },
      // 查看
      view (id) {
        this.$refs.hearderLayoutForm.init('view', {id: id, parent: ''})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.hearderLayoutTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          hearderLayoutService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        hearderLayoutService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        hearderLayoutService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return hearderLayoutService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      },
      statusChange (row) {
        let userObj = JSON.parse(localStorage.getItem('user'))
        this.loading = true
        let query = {
          id: row.id,
          state: row.state,
          name: row.name,
          parentId: row.parentId,
          sort: row.sort,
          url: row.url,
          valEn: row.valEn,
          author: userObj.name
        }
        hearderLayoutService.save(query).then(({data}) => {
          this.$message({
            message: data,
            type: 'success',
            duration: 1500
          })
          this.loading = false
          this.refreshList()
        })
      }
    }
  }
</script>

